import { Grid } from '@mui/material';
import classNames from 'classnames';
import { isValidElement, useState } from 'react';
import { useSelector } from 'react-redux';
import Icon from '/@/components/icon';
import settings from '/@/core/settings';
import { getWeatherFeatureEnabled } from '/@/store/weather/selectors';
import useIsMobile from '/@/utils/hooks/is-mobile';
import WeatherComponent from '/@/views/fields/field-detail/field-weather';
import NOLStyles from '../styles.module.css';
import styles from './styles.module.css';

const NOLItemList = ({ itemList, selectedItem, selectItem, weeds, fieldId, myRecommendations }) => {
    const [showWeatherMobile, setShowWeatherMobile] = useState(true);
    const isMobile = useIsMobile();
    const weatherEnabled = useSelector(getWeatherFeatureEnabled);

    const handleClickWeather = async () => {
        setShowWeatherMobile(false);
    };

    return (
        <div
            className={classNames(
                selectedItem && styles.itemList,
                NOLStyles.border,
                isMobile && !weeds && showWeatherMobile && styles.isMobileWeather
            )}
        >
            <div
                className={classNames(
                    weeds && styles.weeds,
                    weeds && itemList.length === 1 && styles.oneItem,
                    weeds && itemList.length === 2 && styles.twoItem
                )}
            >
                {itemList.map((item) => {
                    return (
                        <Grid container direction='column' key={item.id}>
                            <Grid item>
                                <div
                                    className={classNames(styles.item, {
                                        [styles.disabled]: item.notInteractive,
                                        [styles.selected]: selectedItem && item.type == selectedItem.type,
                                    })}
                                    onClick={(event) => selectItem(item, event)}
                                    key={item.id}
                                >
                                    <Icon
                                        type={item.icon}
                                        className={classNames(
                                            styles.icon,
                                            settings.app.theme !== 'expertobayer' && styles[`color-${item.color}`]
                                        )}
                                        size='xxl'
                                        theme={settings.app.theme === 'expertobayer' ? 'expertobayer' : undefined}
                                    />

                                    <div key={item.id}>
                                        <div
                                            className={classNames(
                                                styles.labelNoColor,
                                                styles.label,
                                                item.icon === 'offline' && styles.offline,
                                                weeds && styles[`color-${item.color}`]
                                            )}
                                        >
                                            {item.label}
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            {isValidElement(item.children) && (
                                <Grid item sx={{ p: 2, width: '100%' }}>
                                    {item.children}
                                </Grid>
                            )}
                        </Grid>
                    );
                })}
            </div>
            {isMobile &&
                !myRecommendations &&
                weatherEnabled &&
                !weeds &&
                (showWeatherMobile ? (
                    <div className={styles.containerCloseWeather}>
                        <Icon
                            size='lg'
                            type='weather'
                            className={classNames(
                                styles.iconWeather,
                                settings.app.theme === 'expertobayer'
                                    ? styles.iconWeatherExpertoBayer
                                    : styles.iconWeatherBlue
                            )}
                            onClick={handleClickWeather}
                        />
                    </div>
                ) : (
                    <div className={classNames(styles.containerCloseWeather)}>
                        <Icon
                            type='close2'
                            theme={settings.app.theme === 'expertobayer' ? 'expertobayer' : undefined}
                            size='xxl'
                            className={styles.iconClose}
                            onClick={() => setShowWeatherMobile(true)}
                        />

                        {fieldId && <WeatherComponent fieldId={fieldId} view='weatherPhone' scrollable />}
                    </div>
                ))}
        </div>
    );
};

export default NOLItemList;
